import request from '../utils/request';

// 分页查询玉石鉴定知识文章列表
export const listJadeIdentificationArticles = (queryDTO = {}) => {
  return request({
    url: '/jade-identification-article/list',
    method: 'post',
    data: queryDTO
  });
};

// 根据ID获取玉石鉴定知识文章详情
export const getJadeIdentificationArticleById = (id) => {
  return request({
    url: `/jade-identification-article/${id}`,
    method: 'get'
  });
};

// 创建玉石鉴定知识文章
export const createJadeIdentificationArticle = (data) => {
  return request({
    url: '/jade-identification-article',
    method: 'post',
    data
  });
};

// 更新玉石鉴定知识文章
export const updateJadeIdentificationArticle = (id, data) => {
  return request({
    url: `/jade-identification-article/${id}`,
    method: 'put',
    data
  });
};

// 删除玉石鉴定知识文章
export const deleteJadeIdentificationArticle = (id) => {
  return request({
    url: `/jade-identification-article/${id}`,
    method: 'delete'
  });
};
